import { render, staticRenderFns } from "./payment-failed-modal.vue?vue&type=template&id=5f22f154"
import script from "./payment-failed-modal.vue?vue&type=script&lang=js"
export * from "./payment-failed-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports